import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

import styles from 'styles/jss/original/components/common/ui/button';

// @ts-expect-error
const useStyles = makeStyles(styles);

type ComponentProps = {
  color?:
    | 'primary'
    | 'secondary'
    | 'info'
    | 'success'
    | 'warning'
    | 'danger'
    | 'rose'
    | 'white'
    | 'twitter'
    | 'facebook'
    | 'google'
    | 'linkedin'
    | 'pinterest'
    | 'youtube'
    | 'tumblr'
    | 'github'
    | 'behance'
    | 'dribbble'
    | 'reddit'
    | 'instagram'
    | 'transparent'
    | 'gray';
  size?: 'sm' | 'lg';
  simple?: boolean;
  round?: boolean;
  fullWidth?: boolean;
  disabled?: boolean;
  block?: boolean;
  link?: boolean;
  justIcon?: boolean;
  fileButton?: boolean;
  children: React.ReactNode;
  className?: string;
  isButton?: boolean;
  onClick?: () => void;
};

const RegularButton = React.forwardRef<HTMLSpanElement & HTMLButtonElement, ComponentProps>(
  (props, ref) => {
    const {
      color = 'primary',
      round,
      children,
      fullWidth,
      disabled,
      simple,
      size = 'button',
      block,
      link,
      justIcon,
      fileButton,
      className = 'default',
      isButton = true,
      onClick,
      ...rest
    } = props;
    const classes = useStyles();
    const btnClasses = classNames({
      [classes.button]: true,
      [classes[size]]: size,
      [classes[color]]: color,
      [classes.round]: round,
      [classes.fullWidth]: fullWidth,
      [classes.disabled]: disabled,
      [classes.simple]: simple,
      [classes.block]: block,
      [classes.link]: link,
      [classes.justIcon]: justIcon,
      [classes.fileButton]: fileButton,
      [className]: className
    });

    return isButton ? (
      <button {...rest} ref={ref} className={btnClasses} onClick={onClick}>
        {children}
      </button>
    ) : (
      <span {...rest} ref={ref} className={btnClasses}>
        {children}
      </span>
    );
  }
);

export default RegularButton;
